<div class="flex">
	<div class="capacity-type">
		<app-dropdown
			[label]="label"
			[itemGroups]="[
				showTitle
					? { title: 'Capacity of ownership', items: capacityOptions }
					: { items: capacityOptions },
			]"
			[ngModel]="selectedCapacityString"
			(onSelect)="setCapacityType($event)"
			[testHook]="testHooks.SelectedCapacityStringDropdown"
		></app-dropdown>
	</div>
</div>
<div
	*ngIf="clientsCapacity?.capacityType === capacityType.TENANTS_IN_COMMON"
	class="flex flex-col mt-5 flex-wrap"
>
	<div class="flex flex-wrap gap-3">
		<div
			*ngFor="
				let share of clientsCapacity?.shares | keyvalue;
				trackBy: trackShare
			"
			class="client-capacity flex items-end flex-1 flex-wrap"
		>
			<app-input
				[label]="share?.value?.name"
				type="number"
				[endIcon]="ICON.PERCENTAGE"
				[ngModel]="share?.value?.share"
				(debounce)="setShare(share.key, $event)"
				[testHook]="testHooks.Input"
			></app-input>
		</div>
	</div>
	<atomic-message-bar
		type="error"
		*ngIf="total !== 100 || showTotalError"
		class="mt-3"
		[@openClose]
		[testHook]="testHooks.MessageBar"
		>Capacities total does not equal 100%</atomic-message-bar
	>
</div>
<div
	*ngIf="clientsCapacity?.capacityType === capacityType.CAPACITY_PER_CLIENT"
	class="flex flex-col mt-5 gap-4"
>
	<div
		*ngFor="
			let share of clientsCapacity.otherCapacity | keyvalue;
			trackBy: trackShare
		"
	>
		<app-container>
			<div *ngIf="share?.value">
				<p class="font-bold mb-2">{{ share.value.name }}</p>
				<div class="flex gap-2">
					<app-dropdown
						label="Capacity of ownership"
						[itemGroups]="[{ items: otherCapacityOptions }]"
						[ngModel]="share?.value?.capacityLabel"
						(onSelect)="setOtherCapacity(share.key, $event)"
						[testHook]="testHooks.CapacityOfOwnershipDropdown"
					></app-dropdown>
					<app-input
						label="Share"
						[ngModel]="share.value.share"
						(debounce)="setOtherCapacityShare(share.key, $event)"
						pattern="^[^&]*$"
						[testHook]="testHooks.Share"
					></app-input>
				</div>
			</div>
		</app-container>
	</div>
</div>
